module.exports = __webpack_public_path__ + "media/images/log/log-graph-sikoku-a7ce5c895e21646d397ef72e7f5488df.svg";